export default {
  ERROR_CODE_MAP: {
    insufficient_balance:
      'You have insufficient funds. Please add more funds to create a return shipping label.',
    no_wallet_added:
      'To purchase your first return shipping label, activate ShipStation carriers ',
    customs_form_required:
      'To complete this international return shipment, a customs declaration is required and must be submitted.',
    name_required:
      'A valid First Name and Last Name is required, update before continuing..',
    po_box_not_allowed:
      'PO Boxes are not a supported address type. Update the address to continue.',
    invalid_address_line1:
      'The address appears to be invalid or missing. Update the address to continue.',
    invalid_city:
      'The address appears to be invalid or missing. Update the address to continue.',
    invalid_address_line2:
      'The address appears to be invalid or missing. Update the address to continue.',
    shipengine_timeout:
      'A shipping rate could not be calculated. Click Calculate to try again. ',
    no_rates_available:
      'A shipping rate could not be calculated. Click Calculate to try again.',
    invalid_dimensions:
      'A shipping rate could not be calculated. Update the package size and click Calculate to try again.',
    unverified_email:
      'Your email address needs to be verified before you can continue. We’ve sent a verification link to your account email.',
    // new error codes
    something_wrong: 'Something went wrong we are looking into it.',
    international_returns_not_allowed:
      "Shipper's ShipperNumber must be the same as the shipments Shipper's country",
    rr_multiple_rsl: 'RequestServiceLevel.MultipleObjectsReturned',
    shipment_already_purchased:
      'Can not purchase label since a label has already been created',
    unsupported_layout: 'layout not supported',
    access_denied: 'access denied',
    invalid_postal_code: 'invalid ship_from postal_code',
    phone_required: 'phone should not be empty',
    invalid_package: 'Invalid package type for carrier(s) provided',
    invalid_carrier_id: 'carrier_id must be an integer',
    invalid_country_code: 'warehouse country_code must be two characters',
    invalid_weight: 'UPS weight limit per package is 150 lbs.'
  }
};
